import React, { useEffect, useState } from 'react';
import logo from '~/_domains/login/logo-color.png';

// Tela de carregamento enquanto os dados do usuário chegam. Os estilos ficam
// aqui dentro de propósito: o CSS do layout ainda não está na página nesse
// momento, e o antigo .pageloader dependia dele (virava uma página branca).

var ESTILO_ANIMACAO = '@keyframes contlabsGiro { to { transform: rotate(360deg); } }'
    + '@keyframes contlabsSurge { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: none; } }';

export var SplashCarregando = function() {
    var demorandoState = useState(false);
    var demorando = demorandoState[0];
    var setDemorando = demorandoState[1];

    useEffect(function() {
        var timer = setTimeout(function() { setDemorando(true); }, 10000);
        return function() { clearTimeout(timer); };
    }, []);

    return (
        <div
            role="status"
            aria-live="polite"
            style={{
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                zIndex: 999998,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(160deg, #f7f2ff 0%, #ffffff 55%, #f5f7fb 100%)',
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            }}
        >
            <style>{ESTILO_ANIMACAO}</style>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', animation: 'contlabsSurge 0.4s ease-out' }}>
                <img src={logo} alt="Contlabs" style={{ width: 180, maxWidth: '60vw', marginBottom: 32 }} />
                <div
                    style={{
                        width: 36,
                        height: 36,
                        borderRadius: '50%',
                        border: '3px solid #e9dcff',
                        borderTopColor: '#722ed1',
                        animation: 'contlabsGiro 0.8s linear infinite',
                    }}
                />
                <div style={{ marginTop: 18, fontSize: 15, color: '#595959' }}>Carregando o Contlabs…</div>
                {demorando && (
                    <div style={{ marginTop: 20, textAlign: 'center', animation: 'contlabsSurge 0.4s ease-out' }}>
                        <div style={{ fontSize: 13, color: '#8c8c8c', marginBottom: 10 }}>
                            Está demorando mais que o normal.
                        </div>
                        <button
                            type="button"
                            onClick={function() { window.location.reload(); }}
                            style={{
                                border: '1px solid #722ed1',
                                background: '#ffffff',
                                color: '#722ed1',
                                borderRadius: 6,
                                padding: '6px 16px',
                                fontSize: 13,
                                cursor: 'pointer',
                            }}
                        >
                            Recarregar
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};
